import { useEffect, useCallback } from 'react';
import useSWR from 'swr';
import axios from 'axios';
import { useAuth } from '../Contexts/AuthContext';

const defaultSwrOptions = { revalidateOnFocus: false };

const useRequest = (url, swrOptions, isBase = true, apiKey) => {
    const { currentUser } = useAuth();
    const { accessToken } = { ...currentUser };
    const isAuthed = currentUser?.isAuthenticated;

    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${accessToken}`,
        'x-api-key': apiKey ? apiKey : '',
    };

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const fetchData = useCallback(async () => {
        if (url.includes('undefined')) {
            return null;
        }
        const requestUrl = isBase ? `${baseURL}${url}` : url;
        return axios.get(requestUrl, { headers });
    }, [baseURL, headers, isBase, url]);

    const {
        data: response,
        error,
        isValidating,
        revalidate,
        mutate,
    } = useSWR(url, fetchData, swrOptions || defaultSwrOptions);

    useEffect(() => {
        if (accessToken && isAuthed && url && !url.includes('undefined')) {
            mutate(); // Force a revalidation when the token changes
        }
    }, [accessToken, isAuthed, mutate, url]);

    return {
        data: response && response.data,
        isValidating,
        error,
        mutate: useCallback(mutate, [mutate]),
        revalidate: useCallback(revalidate, [revalidate]),
    };
};

export default useRequest;
